export const APP_VERSION = '3.28.61';
export const ANDROID_VERSION_CODE = 32861;
